import './App.css';
import Landing from './Landing.jsx';
import AboutMe from './AboutMe.js';
import Header from './Header.js';
import ProfessionalSkills from './ProfessionalSkills.js';
import WorkExperience from './WorkExperience.js';
import Footer from './Footer.js';
import { useRef, useEffect, useState } from 'react';

function App() {
  useEffect(() => {
  const preventGesture = (e) => e.preventDefault();

  const preventPinch = (e) => {
    if (e.touches && e.touches.length > 1) {
      e.preventDefault();
    }
  };

  document.addEventListener("gesturestart", preventGesture, { passive: false });
  document.addEventListener("gesturechange", preventGesture, { passive: false });
  document.addEventListener("gestureend", preventGesture, { passive: false });
  document.addEventListener("touchmove", preventPinch, { passive: false });

  return () => {
    document.removeEventListener("gesturestart", preventGesture);
    document.removeEventListener("gesturechange", preventGesture);
    document.removeEventListener("gestureend", preventGesture);
    document.removeEventListener("touchmove", preventPinch);
  };
}, []);

  const aboutMeRef = useRef(null);
  const skillsRef = useRef(null);
  const workRef = useRef(null);
  const projectsRef = useRef(null);
  const footerRef = useRef(null);
  const headerRef = useRef(null);
  const [hasEnteredSite, setHasEnteredSite] = useState(false);
  const [isHeaderSticky, setIsHeaderSticky] = useState(false);

  useEffect(() => {
  window.scrollTo(0, 0);

  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
}, []);

  useEffect(() => {
    if (!hasEnteredSite) return;

    const handleScroll = () => {
      if (aboutMeRef.current) {
        const top = aboutMeRef.current.getBoundingClientRect().top;
        setIsHeaderSticky(top <= 0);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasEnteredSite]);

  const scrollToRef = (ref, extraOffset = 0) => {
    if (!ref.current) return;

    const headerHeight = headerRef.current?.offsetHeight || 40;
    const elementTop = ref.current.getBoundingClientRect().top + window.scrollY;
    const scrollTarget = elementTop - headerHeight + extraOffset;

    window.scrollTo({
      top: scrollTarget,
      behavior: 'smooth',
    });
  };

  const handleLetsGo = () => {
  setHasEnteredSite(true);

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {

      if (!aboutMeRef.current) return;

      const headerHeight = headerRef.current?.offsetHeight || 40;
      const elementTop =
        aboutMeRef.current.getBoundingClientRect().top + window.scrollY;

      const scrollTarget = elementTop - headerHeight;

      window.scrollTo({
        top: scrollTarget,
        behavior: 'smooth',
      });
    });
  });
};
  
useEffect(() => {
  const body = document.body;

  if (!hasEnteredSite) {
    body.style.overflow = 'hidden';
    body.style.height = '100vh';
  } else {
    body.style.overflow = 'auto';
    body.style.height = 'auto';
  }

  return () => {
    body.style.overflow = 'auto';
    body.style.height = 'auto';
  };
}, [hasEnteredSite]);

  return (
    <div className="App bg-offwhite">
      {!hasEnteredSite && <Landing onLetsGoClick={handleLetsGo} />}

      <div className={hasEnteredSite ? 'page-revealed' : 'page-hidden'}>
        <div ref={aboutMeRef} className="relative">
          {hasEnteredSite && (
            <div className={isHeaderSticky ? 'fixed top-0 left-0 w-full z-50' : ''}>
              <Header
                ref={headerRef}
                onAboutMeClick={() => scrollToRef(aboutMeRef, 0)}
                onWorkExperienceClick={() => scrollToRef(workRef, 0)}
                onProjectsClick={() => scrollToRef(projectsRef, 0)}
                onLinksClick={() => scrollToRef(footerRef, 0)}
              />
            </div>
          )}

          <div className={hasEnteredSite ? 'pt-[40px]' : ''}>
            <AboutMe hasEnteredSite={hasEnteredSite} />

            <div ref={skillsRef}>
              <ProfessionalSkills hasEnteredSite={hasEnteredSite} />
            </div>

            <div ref={workRef}>
              <WorkExperience hasEnteredSite={hasEnteredSite} />
            </div>

            <div ref={footerRef}>
              <Footer hasEnteredSite={hasEnteredSite} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;